export const EMPTY_PARTY = {
  companyName: '', companyAddress1: '', companyAddress2: '', companyCity: '', companyState: 'CA', companyZip: '',
  employeeName: '', employeeAddress1: '', employeeAddress2: '', employeeCity: '', employeeState: 'CA', employeeZip: '',
};

export const partyFromW2 = (p = {}) => ({
  companyName: p.employer_name || '', companyAddress1: p.employer_address1 || '', companyAddress2: p.employer_address2 || '',
  companyCity: p.employer_city || '', companyState: p.employer_state || p.box15_state || 'CA', companyZip: p.employer_zip || '',
  employeeName: p.employee_name || '', employeeAddress1: p.employee_address1 || '', employeeAddress2: p.employee_address2 || '',
  employeeCity: p.employee_city || '', employeeState: p.employee_state || 'CA', employeeZip: p.employee_zip || '',
});

export const partyFromClient = (fd = {}) => Object.fromEntries(
  Object.keys(EMPTY_PARTY).map((k) => [k, fd[k] ?? EMPTY_PARTY[k]]),
);

const inputCls = 'w-full px-3 py-2 rounded-lg bg-zinc-950 border border-zinc-700 text-white text-sm focus:outline-none focus:border-emerald-500';

const PartyBlock = ({ title, prefix, party, onChange }) => {
  const f = (suffix, label, span = '') => (
    <label className={`block ${span}`}>
      <span className="block text-[10px] uppercase tracking-wider text-zinc-500 mb-1">{label}</span>
      <input
        className={inputCls}
        value={party[`${prefix}${suffix}`] || ''}
        onChange={(e) => onChange(`${prefix}${suffix}`, e.target.value)}
        data-testid={`w2studio-${prefix}-${suffix.toLowerCase()}`}
      />
    </label>
  );
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-4 space-y-3">
      <p className="text-xs font-bold uppercase tracking-wider text-zinc-400">{title}</p>
      {f('Name', 'Name')}
      {f('Address1', 'Address line 1')}
      {f('Address2', 'Address line 2')}
      <div className="grid grid-cols-[1fr_70px_100px] gap-2">
        {f('City', 'City')}
        {f('State', 'State')}
        {f('Zip', 'ZIP')}
      </div>
    </div>
  );
};

export const W2PartyForm = ({ party, setParty }) => {
  const onChange = (k, v) => setParty((p) => ({ ...p, [k]: v }));
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="w2studio-party-form">
      <PartyBlock title="Employer (Box c)" prefix="company" party={party} onChange={onChange} />
      <PartyBlock title="Employee (Box e / f)" prefix="employee" party={party} onChange={onChange} />
    </div>
  );
};
